<template>
  <aside
    :class="[
      'side-controls',
      `side-controls--${currentTheme}`,
      { 'side-controls--locked': !isBirthDateValid }
    ]"
  >
    <transition name="fade">
      <a
        v-if="!isFirstSection"
        href="#"
        class="button side-controls__button button side-controls__button--page-up"
        @click="changeSectionBack"
      >
        {{ $t('sideControls.pageUpLabel') }}
      </a>
    </transition>

    <ul class="side-controls__count">
      <li
        v-for="(item, index) in sectionsCount"
        :key="item"
        :class="['side-controls__count-item', { 'side-controls__count-item--active': index === currentSection }]"
        @click="goToSection(index)"
      >
        {{ item }}
      </li>
    </ul>

    <transition name="fade">
      <a
        v-if="!isLastSection && isBirthDateValid"
        href="#"
        class="button side-controls__button side-controls__button--page-down"
        @click="changeSectionForward"
      >
        {{ $t('sideControls.pageDownLabel') }}
      </a>
    </transition>
  </aside>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'SideControls',
  data() {
    return {
      currentTheme: '',
      themes: ['default', 'white'],
    }
  },
  computed: {
    ...mapGetters([
      'isBirthDateValid',
      'isFirstSection',
      'isLastSection',
    ]),
    ...mapState([
      'currentSection',
      'sectionsCount',
    ]),
  },
  watch: {
    currentSection: {
      immediate: true,
      handler() {
        setTimeout(() => {
          this.currentTheme = this.themes[this.currentSection]
        }, 500)
      },
    },
  },
  methods: mapActions([
    'changeSectionBack',
    'changeSectionForward',
    'goToSection',
  ]),
}
</script>
